import React from 'react'

import AuthTemplateVertical from 'components/Auth/AuthTemplateVertical'
import AuthTemplateHorizontal from 'components/Auth/AuthTemplateHorizontal'

import useMediaQuery from 'hooks/useMediaQuery'

const AuthTemplate = props => {
  const { isMobile } = useMediaQuery()

  return (
    isMobile
      ? <AuthTemplateVertical {...props} />
      : <AuthTemplateHorizontal {...props} />
  )
}

export default AuthTemplate
